import React from 'react';
//import config from '../data/config/config.json';
//const imgHome = config.img.home;

export default function Creditos () {
    return (
        <div className="container borde-sencillo-naranja text-center p-2">
            
  
            <strong> Ministra de Educación</strong><br />
            Giselle Cruz Maduro<br /><br />
  
  
            <strong> Viceministerio Académico</strong><br />
            Melania Brenes Monge, viceministra<br />
            Henry Arias Guido, asesor nacional<br /> <br />
  
  
  
            <strong>Dirección de Recursos Tecnológicos</strong><br />
            Gabriela Castro Fuentes, directora<br />
            <strong>Departamento de Gestión y Producción</strong><br />
            <strong>Programadores</strong><br />
            Chacón Campos Luis, asesor nacional de informática  <br />
            Hernández Conejo Patricia, asesora nacional de informática <br />
            Pérez Ramírez Óscar, asesor nacional de informática  <br />
            Araya Salazar Ana Teresa, asesora nacional de informática <br />
            <strong> Diseño gráfico </strong><br />
            Guevara Murillo Karla, diseñadora gráfica  <br /><br />
  
  
  
            <strong>Instituto de Desarrollo Profesional</strong> <br />
            Karla Thomas Powell, directora<br />
            <strong>Dpto de Gestión de Recursos</strong><br />
            Ileana Ruiz Rodríguez, jefatura<br />
            Sigifredo Rojas Vargas, asesor nacional<br /><br />
  
  
            <strong>Dirección de Desarrollo Curricular</strong> <br />
            Ulate Espinoza María Alexandra, directora<br />
            Villalobos Bolaños Heidy, subdirectora <br />
            Campos Quesada Nelson, asesor nacional <br />
            Navarro Mata Tatiana Maria, investigación educativa <br /> <br />
  
  
            <strong>Departamento de Educación de la Primera Infancia </strong> <br />
            Alpizar Elizondo Guisselle, jefatura<br />
            Chaves León Gloria Rocío, asesoras nacionales <br />
            Madrigal Rojas  Vera<br />
            López Castillo Carolina<br />
            Madrigal López  Elizabeth <br />
            Díaz Madriz Adriana<br />
            Gamboa Naranjo Gabriela<br />
            Montoya García Ofelia<br />
            Coto Jiménez Johanna<br />
            Chaves Solís Xinia Patricia <br />
            Wong Apuy Maritza<br />
            Guardado García Yamileth<br /><br />
  
  
            <strong>Departamento de Educación de Personas Jóvenes y Adultos  </strong> <br />
            Alvarado Alvarado Marielos, jefatura<br />
            Aguilar Rojas Jean Carlo<br />
            Benavides Román Luis Miguel<br />
            Cerdas Solano Jaime Guillermo<br />
            Guevara Torres Silvia<br />
            Hérnandez López Manuel<br />
            Rojas Gutiérrez María Isabel<br />
            Umaña Benavides Maritza<br />
            Víquez Ortiz María Fernanda<br />
            Zamora Lazo Patricia<br /><br />
  
  
  
            <strong>Departamento de Educación Intercultural </strong> <br />
            Estrada Torres José Víctor, jefatura <br />
            Smith Castro Anger <br />
            Delgado Morales Patricia<br />
            Pineda Rodríguez Victor<br />
            Santacruz Molina Juan Carlos <br />
            Rojas Chaves Carmen <br />
            González Morales Maylin Eusebia<br />
            Zuñiga Hernandez Fidelia<br />
            Andrade Santos Gerardo<br /><br />
  
            <strong>Departamento de Educación Religiosa</strong> <br />
            Salazar Porras José Marvin, jefatura<br />
            Fernández Picado Marco Antonio <br />
            Mora Castillo Magalli<br />
            Fallas Mora Seidy<br /><br />
  
  
            <strong>Departamento de Evaluación de los Aprendizajes </strong> <br />
            Torres Arias Rocío, jefatura <br />
            Badilla Calderón Lilliam<br />
            Mora Guillén Ivannia <br />
            Leiva Méndez Julio César<br />
            Montoya Vargas Vera Rebeca<br />
            Marchena López Jorge <br />
            Barrantes Benavides Jockling<br /><br />
  
            <strong>Departamento de Primer y Segundo Ciclo</strong> <br />
            Venegas Fernández Anabelle, jefatura <br />
            Araya Fonseca Evelyn <br />
            Blanco Retana Bismarck <br />
            Calderón Solano Cecilia<br />
            Campos Centeno Ana Isabel <br />
            Valverde Rojas Marjorie<br />
            Fatjó Olasz Olga <br />
            Mena Picado Hermes<br />
            Navarro Garro Richard <br />
            Ramírez Chavarría Rosalia<br />
            Ramírez Vázquez Yaudy <br />
            Rosales Rodríguez María Luisa<br />
            Sequeira Sandoval Johnny <br />
            Solano Navarro Ruth<br />
            Varela Jara Edgar<br />
            Zuñiga Esquivel Xinia Liseth<br /><br />
  
            <strong>Departamento de Tercer Ciclo y Educación Diversificada </strong> <br />
            Corrales Zuñiga Rigoberto, jefatura <br />
            Aguilar Cabezas Ruth <br />
            Alpízar Mora Karla Gabriela<br />
            Alvarado Cruz  Ángel<br />
            Bermúdez Vives Carlos<br />
            Carvajal Barrantes Marvin<br />
            Chacón Navarro Jonathan Gerardo<br />
            De Lemos Morales Gustavo Adolfo<br />
            Granados Carvajal, María Maleni<br />
            Granados Sirias Marianella<br />
            Hernández  Quesada Oscar F.<br />
            Lara Bolaños Laura<br />
            Lizano Argüello Paula María<br />
            Martínez Rodríguez Roxana<br />
            Montoya Vargas, Luis Ricardo<br />
            Ortega Cordero Alfredo<br />
            Parés Zamora Monserrat <br />
            Parra Brenes Mónica<br />
            Quesada Campos, Yeimy<br />
            Quiros Quiros Hannia<br />
            Ramos Torres Yeimer<br />
            Rodriguez Gonzalez Eugenia M°<br />
            Rivera Espinoza Jenny Patricia<br />
            Salas Fonseca Gina Patricia <br />
            Sandí Ureña Rita<br />
            Serrano Echeverría Juan Pablo <br />
            Sevilla Solano Cecilia <br />
            Villegas Gacía Ana Lorena<br /><br />
  
            <strong>Departamento de Apoyos Educativos para el Estudiantado con Discapacidad </strong> <br />
            Aguilar Montoya Gilda María, jefatura <br />
            Segura Castillo Mario <br />
            Quirós Acuña Maybel <br />
            Cubero Orias Laura Jenenthe<br />
            Carvajal Granados Laurita <br />
            Jiménez Hidalgo Celia <br />
            Rivera Sánchez Paola <br />
            Barboza Zuñiga Nancy<br />
            Sánchez Duran Sileny <br />
            Fallas Moya Lisandro<br />
            Rodriguez Calvo Mariela<br />
            Alvarez Rodríguez Carolina<br />
            Rojas Vargas Lianeth<br /><br />
  
  
            <strong>Unidad de alta Dotación </strong> <br />
            Murillo Mayorga Alexander, jefatura<br />
            Marín Rojas Gina<br />
            Morales Palma Yamilette <br />
            Villalobos Chan Sandra Graciela<br />
            Ramírez Campos Ana Maria<br /><br />
  
  
            <strong>Fuente</strong> <cite> :   MEP.Costa Rica - Enero  </cite>
        </div>
    )
    
}